<template>
  <div id="contenedor-presupuestos-toolbar">
    <v-toolbar flat dense>
      <custom-select
        cols="auto"
        v-model="ejercicio"
        label="Ejercicio*"
        :items="ejercicios"
        :rules="[mixReglas.requerido]"
        required>
      </custom-select>
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevo">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'ToolBarPresupuestos',
  components: {
    CustomButton,
    CustomSelect,
  },
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
  },
  data() {
    return {
      ejercicios: [],
    };
  },
  mounted() {
    this.setEjercicios();
  },
  methods: {
    setEjercicios() {
      this.ejercicios = [];
      const yr = Number(new Date().toISOString().substr(0, 4));
      const min = yr - 10;
      const max = yr + 1;
      // eslint-disable-next-line no-plusplus
      for (let index = max; index >= min; index--) {
        this.ejercicios.push(index);
      }
    },
    nuevo() {
      this.$emit('nuevoPresupuesto');
    },
  },
  computed: {
    ejercicio: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
